import { createSelector } from 'reselect'

// TODO: importing from /duck instead of /duck/selectors creates a circular
// dependency. Fix it and import properly.
import { getDashboardState } from '../duck/selectors'

export const getDataState = createSelector(getDashboardState, (dashboardState) => dashboardState.data)

export const getIsDataLoading = createSelector(getDataState, ({ organizations, investorChecks, deals }) => {
  return organizations.isFetching || investorChecks.isFetchingAvailableChecks || deals.isFetching
})
